// extracted by mini-css-extract-plugin
export default {"homeAdvertList":"c-c_cZ","homeAdvertList__cardListContainer":"c-c_ea","homeAdvertList__loadMoreContainer":"c-c_eb"};